import { __rest } from "tslib";
import { log } from 'type-r';
export function create(url, fetchOptions) {
    return new RestfulEndpoint(url, fetchOptions);
}
export { create as restfulIO };
export class RestfulEndpoint {
    constructor(url, _a = {}) {
        var { mockData, simulateDelay = 1000 } = _a, fetchOptions = __rest(_a, ["mockData", "simulateDelay"]);
        this.url = url;
        this.fetchOptions = fetchOptions;
    }
    create(json, options, record) {
        const url = this.collectionUrl(record, options);
        return this.request('POST', url, options, json);
    }
    update(id, json, options, record) {
        const url = this.objectUrl(record, id, options);
        return this.request('PUT', url, options, json);
    }
    read(id, options, record) {
        const url = this.objectUrl(record, id, options);
        return this.request('GET', url, options);
    }
    destroy(id, options, record) {
        const url = this.objectUrl(record, id, options);
        return this.request('DELETE', url, options);
    }
    list(options, collection) {
        const url = this.collectionUrl(collection, options);
        return this.request('GET', url, options);
    }
    subscribe(events) { }
    unsubscribe(events) { }
    isRelativeUrl(url) {
        return url.indexOf('./') === 0;
    }
    removeTrailingSlash(url) {
        const endsWithSlash = url.charAt(url.length - 1) === '/';
        return endsWithSlash ? url.substr(0, url.length - 1) : url;
    }
    getRootUrl(recordOrCollection) {
        const { url } = this;
        if (this.isRelativeUrl(url)) {
            const owner = recordOrCollection.getOwner(), ownerUrl = owner.getEndpoint().getUrl(owner);
            return this.removeTrailingSlash(ownerUrl) + '/' + url.substr(2);
        }
        else {
            return url;
        }
    }
    getUrl(record) {
        const url = this.getRootUrl(record);
        return record.isNew()
            ? url
            : this.removeTrailingSlash(url) + '/' + record.id;
    }
    objectUrl(record, id, options) {
        return appendParams(this.getUrl(record), options.params);
    }
    collectionUrl(collection, options) {
        return appendParams(this.getRootUrl(collection), options.params);
    }
    buildRequestOptions(method, options, body) {
        const mergedOptions = Object.assign(Object.assign(Object.assign({}, RestfulEndpoint.defaultFetchOptions), this.fetchOptions), options);
        const { headers } = mergedOptions, rest = __rest(mergedOptions, ["headers"]), resultOptions = Object.assign({ method, headers: Object.assign({ 'Content-Type': 'application/json' }, headers) }, rest);
        if (body) {
            resultOptions.body = JSON.stringify(body);
        }
        return resultOptions;
    }
    request(method, url, { options }, body) {
        return fetch(url, this.buildRequestOptions(method, options, body))
            .then(response => {
            if (response.ok) {
                return response.json();
            }
            else {
                throw new Error(response.statusText);
            }
        });
    }
}
RestfulEndpoint.defaultFetchOptions = {
    cache: "no-cache",
    credentials: "same-origin",
    mode: "cors",
    redirect: "error",
};
function appendParams(url, params) {
    var esc = encodeURIComponent;
    return params
        ? url + '?' + Object.keys(params)
            .map(k => esc(k) + '=' + esc(params[k]))
            .join('&')
        : url;
}
function simulateIO() {
    log("info", 'SimulatedIO', `GET ${this.url}`);
}
//# sourceMappingURL=restful.js.map